export default __webpack_public_path__ + "static/media/data-transfer-square.c6967c55.svg";